import Vue from "vue/dist/vue.esm";
import VueI18n from "vue-i18n";
import "/events/load-plans";
import events from "/events";
import getLocale from "/utils/locale";
import TrialDurationExplanation from "/features/trial-duration-explanation/components/trial-duration-explanation";

Vue.use(VueI18n);

const container = document.querySelector(".js-trial-duration-explanation");

const init = (container, subscriptionPlans) => {
  if (!container) return;

  const {
    ctaCopy,
    ctaJsClass,
    piwikCategory
  } = container.dataset;

  const subscriptionPlanDuration = parseInt(container.dataset.subscriptionPlanDuration, 10);

  const subscriptionPlan = subscriptionPlans.find(plan => {
    return plan.duration === subscriptionPlanDuration;
  });

  if (!subscriptionPlan) {
    return;
  }

  new Vue({
    name: "TrialDurationExplanationInit",
    el: container,
    i18n: new VueI18n({ locale: getLocale() }),
    render: h => h(TrialDurationExplanation, {
      props: {
        ctaCopy,
        ctaJsClass,
        piwikCategory,
        subscriptionPlan
      }
    })
  });
};

events.on("plans:ready", data => {
  if (!data.canTrial) {
    return;
  }

  init(container, data.plans);
});
